import { render, staticRenderFns } from "./NFT.vue?vue&type=template&id=1504ef7a&scoped=true&"
import script from "./NFT.vue?vue&type=script&lang=ts&"
export * from "./NFT.vue?vue&type=script&lang=ts&"
import style0 from "./NFT.vue?vue&type=style&index=0&id=1504ef7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504ef7a",
  null
  
)

export default component.exports